import { addMinutes, differenceInMinutes } from "date-fns";

export function calculateAutoBreakTimes(
  clockInTime: Date,
  clockOutTime: Date,
  mandatoryBreakDurationInMinutes: number
) {
  const shiftDurationMinutes = differenceInMinutes(clockOutTime, clockInTime);

  const halfShiftMinutes = shiftDurationMinutes / 2;

  const autoBreakStartTime = addMinutes(clockInTime, halfShiftMinutes);
  const autoBreakEndTime = addMinutes(autoBreakStartTime, mandatoryBreakDurationInMinutes);

  return { autoBreakStartTime, autoBreakEndTime };
}
